var title = '名称';
export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return "".concat(pageTitle);
    //return `${pageTitle} - ${title}`
  }

  return "".concat(title);
}